function bindCarouselPagination(swiper, sectionRoot, selectors) {
  const progressEl = sectionRoot.querySelector(selectors.progress);
  const counterEl = sectionRoot.querySelector(selectors.counter);
  const prevBtn = sectionRoot.querySelector(selectors.prev);
  const nextBtn = sectionRoot.querySelector(selectors.next);

  const update = () => {
    const allSlides = Array.from(swiper.slides || []);
    // Only count visible slides (supports future tag filtering DOM updates)
    const visibleSlides = allSlides.filter((sl) => sl.style.display !== "none");
    
    // Calculate total standard blogs
    const highlightCount = visibleSlides.filter((sl) => sl.querySelector(".vp-featured-blogs__highlight")).length;

    const totalBlogs = Math.max(1, visibleSlides.length - highlightCount);
    // Figure out how many slides are visible at once right now
    let spv = 1;
    if (typeof swiper.params.slidesPerView === "number") {
      spv = Math.floor(swiper.params.slidesPerView);
    }
    
    // Find the rightmost visible slide's index natively
    const activeIndex = swiper.activeIndex || 0;
    let rightmostIdx = activeIndex + spv - 1;
    if (rightmostIdx >= visibleSlides.length) {
      rightmostIdx = visibleSlides.length - 1;
    }
    
    // Count how many standard blogs exist up to and including the rightmost slide
    const visibleBlogsUpToRightmost = visibleSlides
      .slice(0, rightmostIdx + 1)
      .filter((sl) => !sl.querySelector(".vp-featured-blogs__highlight")).length;
      
    // Default to 1 if we're only looking at the highlight card
    const current = Math.max(1, visibleBlogsUpToRightmost);

    // Calculate progress fraction
    const pct = totalBlogs > 0 ? (current / totalBlogs) * 100 : 0;

    if (progressEl) progressEl.style.width = `${pct}%`;
    if (counterEl) {
      counterEl.textContent = `${String(current).padStart(2, "0")}/${String(totalBlogs).padStart(2, "0")}`;
    }
  };

  update();
  swiper.on("slideChange transitionEnd", update);

  if (prevBtn) prevBtn.addEventListener("click", () => swiper.slidePrev());
  if (nextBtn) nextBtn.addEventListener("click", () => swiper.slideNext());
}


function buildSwiperSlider(sectionRoot, cardsContainer, sliderClass, navIdPrefix) {
  const cardCount = cardsContainer.children.length;
  if (cardCount === 0) return null;

  const sectionId =
    sectionRoot.dataset.sectionId || (sectionRoot.closest("[id^='shopify-section-']")?.id || "").replace("shopify-section-", "");

  const mobileLayout = cardsContainer.dataset.mobileLayout || "slider";
  const isMobileSlider = mobileLayout === "slider";

  const swiperSlider = document.createElement("swiper-slider");
  swiperSlider.setAttribute("data-swiper-id", "vp-featured-blogs");
  swiperSlider.setAttribute("data-mobile-layout", mobileLayout);
  swiperSlider.className = sliderClass;
  swiperSlider.dataset.swiperConfig = JSON.stringify({
    navigation: {
      enabled: true,
      nextEl: sectionId ? `#${navIdPrefix}-next-${sectionId}` : `[data-${navIdPrefix}-next]`,
      prevEl: sectionId ? `#${navIdPrefix}-prev-${sectionId}` : `[data-${navIdPrefix}-prev]`,
    },
    pagination: { enabled: false },
    spaceBetween: 0,
    breakpoints: {
      0: { 
        enabled: isMobileSlider,
        spaceBetween: 0,
        slidesPerView: isMobileSlider ? 1 : "auto"
      },
      750: { 
        enabled: true,
        spaceBetween: 0,
        slidesPerView: 2
      },
      990: {
        enabled: true,
        spaceBetween: 0,
        slidesPerView: 4
      }
    }
  });

  const swiperEl = document.createElement("div");
  swiperEl.className = "swiper";

  const wrapper = document.createElement("div");
  wrapper.className = "swiper-wrapper";
  wrapper.setAttribute("role", "list");
  wrapper.id = cardsContainer.id || "";
  wrapper.dataset.blockCount = cardsContainer.dataset.blockCount || String(cardCount);

  // Move all children of the cardsContainer into swiper-slide wrappers
  while (cardsContainer.firstElementChild) {
    const child = cardsContainer.firstElementChild;
    const slide = document.createElement("div");
    slide.className = "swiper-slide";
    
    if (child.classList.contains("hide-on-mobile")) {
      slide.classList.add("hide-on-mobile");
    }
    
    slide.appendChild(child);
    wrapper.appendChild(slide);
  }

  swiperEl.appendChild(wrapper);
  swiperSlider.appendChild(swiperEl);
  cardsContainer.parentNode.replaceChild(swiperSlider, cardsContainer);
  return swiperSlider;
}

function initVpFeaturedBlogsSection(section) {
  const cardsContainer = section.querySelector("[data-vp-featured-blogs-cards]");
  if (!cardsContainer) return;

  const swiperSlider = buildSwiperSlider(section, cardsContainer, "vp-featured-blogs-slider", "vp-blog");
  if (!swiperSlider) return;

  // -- Dynamic JS Filtering --
  const swiperWrapper = swiperSlider.querySelector(".swiper-wrapper");
  const allSlides = Array.from(swiperWrapper.querySelectorAll(".swiper-slide"));
  
  const categoryBtns = section.querySelectorAll(".vp-blog-category-btn");
  if (categoryBtns.length > 0) {
    categoryBtns.forEach(btn => {
      btn.addEventListener("click", e => {
        if (!btn.hasAttribute("data-tag")) return; 
        
        e.preventDefault();
        const targetTag = btn.dataset.tag || "";
        
        categoryBtns.forEach(b => b.classList.remove("vp-blog-category-btn--active"));
        btn.classList.add("vp-blog-category-btn--active");
        
        const filteredSlides = allSlides.filter(slide => {
          const card = slide.querySelector(".vp-blog-card");
          if (!card) return true; // Keep highlight/feature card always
          if (!targetTag) return true; // Keep all if "ALL" selected
          
          const tags = (card.dataset.tags || "").split(",");
          return tags.includes(targetTag);
        });
        
        swiperWrapper.innerHTML = "";
        filteredSlides.forEach(slide => swiperWrapper.appendChild(slide));
        
        if (swiperSlider.swiper) {
          swiperSlider.swiper.update();
          swiperSlider.swiper.slideTo(0, 0);
          swiperSlider.swiper.emit("transitionEnd");
        }
      });
    });
  }

  setTimeout(() => {
    const swiperInstance = swiperSlider.swiper;
    if (swiperInstance) {
      bindCarouselPagination(swiperInstance, section, {
        progress: ".vp-featured-blogs__pagination-progress",
        counter: "[data-vp-featured-blogs-counter]",
        prev: "[data-vp-featured-blogs-prev]",
        next: "[data-vp-featured-blogs-next]",
      });
    }
  }, 0);
}

function initAllVpFeaturedBlogsSections() {
  document.querySelectorAll(".vp-featured-blogs").forEach(initVpFeaturedBlogsSection);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    customElements.whenDefined("swiper-slider").then(initAllVpFeaturedBlogsSections);
  });
} else {
  customElements.whenDefined("swiper-slider").then(initAllVpFeaturedBlogsSections);
}

document.addEventListener("shopify:section:load", (e) => {
  if (e.target.querySelector(".vp-featured-blogs")) {
    initAllVpFeaturedBlogsSections();
  }
});
